import "./GlobalStyle.scss";
export default function GlobalStyles({ children }) {
  return children;
}
